import React, { useState } from 'react';
import { Button, Form, Card, Table, Spinner } from 'react-bootstrap';

const SolicitudCambios = ({ items = [], onEnviar, loading = false }) => {
  const [seleccionados, setSeleccionados] = useState({});

  const toggleItem = (index) => {
    setSeleccionados(prev => {
      const nuevo = { ...prev };
      if (nuevo[index]) {
        delete nuevo[index];
      } else {
        nuevo[index] = { tipo_cambio: 'eliminar', cantidad_sugerida: '', comentario_cliente: '' };
      }
      return nuevo;
    });
  };

  const actualizarCampo = (index, campo, valor) => {
    setSeleccionados(prev => ({
      ...prev,
      [index]: { ...prev[index], [campo]: valor }
    }));
  };

  const handleEnviar = () => {
    const solicitudes = Object.entries(seleccionados).map(([index, datos]) => ({
      item_index: parseInt(index),
      tipo_cambio: datos.tipo_cambio,
      ...(datos.tipo_cambio === 'reducir_cantidad' && datos.cantidad_sugerida && {
        cantidad_sugerida: Number(datos.cantidad_sugerida)
      }),
      ...(datos.comentario_cliente && { comentario_cliente: datos.comentario_cliente })
    }));
    onEnviar(solicitudes);
  };

  const haySeleccionados = Object.keys(seleccionados).length > 0;

  return (
    <Card className="mt-3 w-100">
      <Card.Header className='w-100'>
        <h5 className="mb-0">Solicitar Cambios</h5>
      </Card.Header>
      <Card.Body className='w-100'>
        <p className="text-muted mb-3">Seleccione los ítems sobre los que desea solicitar cambios:</p>
        <Table responsive size="sm">
          <thead>
            <tr>
              <th style={{ width: '40px' }}></th>
              <th>Ítem</th>
              <th>Cantidad</th>
              <th>Tipo de cambio</th>
              <th>Nueva cantidad</th>
              <th>Comentario</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <React.Fragment key={index}>
                <tr>
                  <td>
                    <Form.Check
                      type="checkbox"
                      checked={!!seleccionados[index]}
                      onChange={() => toggleItem(index)}
                    />
                  </td>
                  <td>{item.item_id?.nombre || item.nombre || `Ítem ${index + 1}`}</td>
                  <td>{item.cantidad}</td>
                  <td>
                    {seleccionados[index] && (
                      <Form.Select
                        size="sm"
                        value={seleccionados[index].tipo_cambio}
                        onChange={(e) => actualizarCampo(index, 'tipo_cambio', e.target.value)}
                      >
                        <option value="eliminar">Eliminar</option>
                        <option value="reducir_cantidad">Cambiar cantidades</option>
                        <option value="solicitar_descuento">Solicitar descuento</option>
                      </Form.Select>
                    )}
                  </td>
                  <td>
                    {seleccionados[index]?.tipo_cambio === 'reducir_cantidad' && (
                      <Form.Control
                        size="sm"
                        type="number"
                        min="1"
                        placeholder="Cantidad"
                        value={seleccionados[index].cantidad_sugerida}
                        onChange={(e) => actualizarCampo(index, 'cantidad_sugerida', e.target.value)}
                      />
                    )}
                  </td>
                  <td>
                    {seleccionados[index] && (
                      <Form.Control
                        size="sm"
                        type="text"
                        placeholder="Comentario (opcional)"
                        value={seleccionados[index].comentario_cliente}
                        onChange={(e) => actualizarCampo(index, 'comentario_cliente', e.target.value)}
                      />
                    )}
                  </td>
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </Table>

        {haySeleccionados && (
          <div className="text-end mt-3">
            <Button
              variant="warning"
              onClick={handleEnviar}
              disabled={loading}
            >
              {loading ? <><Spinner size="sm" animation="border" /> Enviando...</> : 'Enviar solicitud de cambios'}
            </Button>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default SolicitudCambios;
